import { useClasser } from "@code-hike/classer";
import * as React from "react";
import { useErrorMessage } from "../hooks/useErrorMessage";
export var ErrorOverlay = function ErrorOverlay() {
  var errorMessage = useErrorMessage();
  var c = useClasser("sp");

  if (!errorMessage) {
    return null;
  }

  return React.createElement("div", {
    className: c("overlay", "error")
  }, React.createElement("div", {
    className: c("error-message")
  }, errorMessage));
};